export default function getDateFormat(date:any){
    const day:string = new Date(Date.parse(date)).getUTCDate().toString()
    const month:string = (new Date(Date.parse(date)).getUTCMonth() + 1).toString()
    const year:string = new Date(Date.parse(date)).getUTCFullYear().toString()
    const hour:string = new Date(Date.parse(date)).getUTCHours().toString()
    const minute:string = new Date(Date.parse(date)).getUTCMinutes().toString()
    const seconds:string = new Date(Date.parse(date)).getUTCSeconds().toString()
    const dateFormat = `${year}-${month.length===1?'0'+month: month}-${day.length === 1? '0'+day:day} ${hour.length===1?'0'+hour:hour}:${minute.length===1?'0'+minute:minute}:${seconds.length===1?'0'+seconds:seconds}`
    return dateFormat
}